import { useContext } from 'react';

import { QualityAssuranceNamespaceContext } from './QualityAssuranceNamespaceContext';

/**
 * Works with combination of QaNamespace component
 *
 * reads namespace name from QaNamespaceContext, appends suffix if one was provided to it
 *
 * if not wrapped will be just undefined.
 *
 * example:
 * ```
 * <QaNamespace namespace="new-adress">
 *    <MyForm>
 *        <Myinput name="joe">
 *        <Myinput name="doe"
 * ```
 * in MyForm
 * const qaId = useQaNamespace({suffix: 'form'}) // new-address-form // new-address from QaNamespace + suffix
 * <form data-qa-id=qaId>
 *
 * in MyInput
 * const name = props.name
 * const qaId = useQaNamespace({suffix: name}) // new-address-form-${name}
 * <input dataQaid={qaId}>
 *
 * basically makes building data-qa-ids easier without having to manually pass them
 *
 * @param suffix a string suffix that will be appended to a namespace
 * @see useQaNamespace
 */
export const useQaNamespace = ({ suffix = '' }: { suffix?: string }) => {
  const dataDaNamespaceContext: string = useContext(QualityAssuranceNamespaceContext)
    ? `${useContext(QualityAssuranceNamespaceContext)}-`
    : '';

  return `${dataDaNamespaceContext}${suffix}`;
};
